

export default function () {
    //console.log('*****in set topic reducer*******');
        return [
          'TRANSWELL',
        ];
}



// WEBPACK FOOTER //
// ./src/reducers/reducer-topicList.js